<template lang="pug">

	b-form-group(:label="_field.label" :description="_field.help")
		b-input-group
			b-input-group-prepend(v-if="_field.icon")
				b-input-group-text
					i(:class='_field.icon')
			select.form-control.mb-2.mb-md-0.w-100(v-bind="_field.attrs" :name="_field.name" :default="_field.default" v-bind:value="value" @input="input")
				option(:value="_field.default.value" v-if="_field.default") {{ _field.default.text }}
				optgroup(:label="opgroup.label" v-for="opgroup in _field.options")
					option(:value="option.value" v-for="option in opgroup.options") {{ option.text }}
			b-form-invalid-feedback {{ _invalidFeedback(_field.name) }}
</template>
<script>
	export default {
		name: 'Info',
		props: ['value', '_field', '_invalidFeedback', '_checkState'],
		methods: {
			input($event){
				this.$emit('input', $event.target.value)
			}
		},
	};
</script>
